import { createTheme } from "@material-ui/core";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#d1a96f",
      light: "#e0c69e",
    },
    secondary: {
      main: "#d1a96f",
    },
  },
  overrides: {
    /*
      MUI draws its buttons the Material way: a 4px rectangle of wide-tracked capitals. Next to
      the portal's own gold button — a 20px pill in sentence case — the same action looked like
      two different controls depending on which toolbar it happened to sit in. These overrides
      settle it in one place, for every MUI button in the portal.
    */
    MuiButton: {
      root: {
        textTransform: "none",
        letterSpacing: "0.01em",
        borderRadius: 20,
        fontFamily: "'proxima-nova', sans-serif",
        fontWeight: 700,
      },
      // Filled gold: black text, and a darker gold on hover rather than a translucent one,
      // which on a filled control reads as fading rather than pressing.
      /*
        These are plain CSS declarations, so unlike palette.primary.main they can hold a var()
        and follow the theme. That distinction matters: with a literal here, every MUI button on
        the page stayed #DEBB68 while the rest of the portal moved to the Hub's #D8A24A, which
        is why Open, Grading and Add Card to Grading were a visibly different gold from the
        filter controls above them.
      */
      containedPrimary: {
        color: "#000000",
        backgroundColor: "rgb(var(--pcg-gold))",
        "&:hover": { backgroundColor: "rgb(var(--pcg-gold-dark))" },
      },
      outlinedPrimary: {
        borderColor: "rgb(var(--pcg-gold) / 0.45)",
        color: "rgb(var(--pcg-gold))",
        "&:hover": {
          borderColor: "rgb(var(--pcg-gold))",
          backgroundColor: "rgb(var(--pcg-gold) / 0.08)",
        },
      },
    },
    MuiGrid: {
      "spacing-xs-2": {
        width: "calc(99% + 16px)",
      },
    },
  },
});
